import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { WalletProvider } from './context/WalletContext';
import { CollectiveFundsProvider } from './context/CollectiveFundsContext';
import { DrawProvider } from './context/DrawContext';
import { DrawAdminProvider } from './context/DrawAdminContext';
import { DrawParticipantsProvider } from './context/DrawParticipantsContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Home } from './pages/Home';
import { Tirages } from './pages/Tirages';
import { EditRequest } from './pages/EditRequest';
import { CreateRequest } from './pages/CreateRequest';
import { TwoDR } from './pages/TwoDR';
import { Profile } from './pages/Profile';
import { PublicProfile } from './pages/PublicProfile';
import { ProfileSettings } from './pages/ProfileSettings';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { TransactionHistory } from './pages/TransactionHistory';
import { RequestDetails } from './pages/RequestDetails';
import { UsernameHistory } from './pages/UsernameHistory';
import { useEffect } from 'react';
import { updateAllUsers, updateExistingUsersWithReferralCodes } from './utils/databaseUpdates';
import { initializeFirebaseSettings } from './config/firebase';
import { CollectiveInvestmentProvider } from './context/CollectiveInvestmentContext';
import { NotificationProvider } from './context/NotificationContext';
import { ProfileSettingsProvider } from './context/ProfileSettingsContext';
import { DonationPage } from './pages/DonationPage';
import { DonorsList } from './pages/DonorsList';
import { Top } from './pages/Top';
import { Notifications } from './pages/Notifications';
import { GeneralDonationDrawProvider } from './context/GeneralDonationDrawContext';
import { DonationPreview } from './pages/DonationPreview';
import { DonationLanding } from './pages/DonationLanding';
import { SharedRequestDetails } from './pages/SharedRequestDetails';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import { ReferralRedirect } from './pages/ReferralRedirect';
import { TopDonorsProvider } from './context/TopDonorsContext';
import { UpdateNotifier } from './components/InstallButton';

function App() {
  useEffect(() => {
    // Exécuter la mise à jour une seule fois
    updateAllUsers();
  }, []);

  useEffect(() => {
    // Exécuter la mise à jour des codes de parrainage une seule fois
    updateExistingUsersWithReferralCodes();
  }, []);

  useEffect(() => {
    // Déplacer l'initialisation avant les autres providers
    const initializeApp = async () => {
      try {
        await initializeFirebaseSettings();
      } catch (error) {
        console.error('Erreur d\'initialisation Firebase:', error);
      }
    };
    initializeApp();
  }, []);

  return (
    <AuthProvider>
      <ProfileSettingsProvider>
        <WalletProvider>
          <TopDonorsProvider>
            <NotificationProvider>
              <DrawAdminProvider>
                <DrawParticipantsProvider>
                  <GeneralDonationDrawProvider>
                    <CollectiveFundsProvider>
                      <DrawProvider>
                        <CollectiveInvestmentProvider>
                          <AudioPlayerProvider>
                            <Layout>
                              <Routes>
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/" element={
                                  <ProtectedRoute>
                                    <Home />
                                  </ProtectedRoute>
                                } />
                                <Route path="/tirages" element={
                                  <ProtectedRoute>
                                    <Tirages />
                                  </ProtectedRoute>
                                } />
                                <Route path="/2dr/create" element={
                                  <ProtectedRoute>
                                    <CreateRequest />
                                  </ProtectedRoute>
                                } />
                                <Route path="/2dr/edit/:id" element={
                                  <ProtectedRoute>
                                    <EditRequest />
                                  </ProtectedRoute>
                                } />
                                <Route path="/2dr" element={
                                  <ProtectedRoute>
                                    <TwoDR />
                                  </ProtectedRoute>
                                } />
                                <Route path="/2dr/shared/:id" element={<SharedRequestDetails />} />
                                <Route path="/2dr/request/:id" element={<RequestDetails />} />
                                <Route path="/2dr/request/:id/donate" element={
                                  <ProtectedRoute>
                                    <DonationPage />
                                  </ProtectedRoute>
                                } />
                                <Route path="/2dr/request/:id/donate/anonymous" element={<DonationPage />} />
                                <Route path="/2dr/request/:id/donors" element={
                                  <ProtectedRoute>
                                    <DonorsList />
                                  </ProtectedRoute>
                                } />
                                <Route path="/profil" element={
                                  <ProtectedRoute>
                                    <Profile />
                                  </ProtectedRoute>
                                } />
                                <Route path="/profil/:userId" element={<PublicProfile />} />
                                <Route path="/profil/settings" element={
                                  <ProtectedRoute>
                                    <ProfileSettings />
                                  </ProtectedRoute>
                                } />
                                <Route path="/privacy" element={<PrivacyPolicy />} />
                                <Route path="/terms" element={<TermsOfUse />} />
                                <Route path="/transactions" element={
                                  <ProtectedRoute>
                                    <TransactionHistory />
                                  </ProtectedRoute>
                                } />
                                <Route path="/username-history/:userId" element={<UsernameHistory />} />
                                <Route path="/top" element={
                                  <ProtectedRoute>
                                    <Top />
                                  </ProtectedRoute>
                                } />
                                <Route path="/notifications" element={
                                  <ProtectedRoute>
                                    <Notifications />
                                  </ProtectedRoute>
                                } />
                                <Route path="/donation/:id/preview" element={<DonationPreview />} />
                                <Route path="/donation/:id" element={<DonationLanding />} />
                                <Route path="/parrainage/:code" element={<ReferralRedirect />} />
                              </Routes>
                            </Layout>
                          </AudioPlayerProvider>
                        </CollectiveInvestmentProvider>
                      </DrawProvider>
                    </CollectiveFundsProvider>
                  </GeneralDonationDrawProvider>
                </DrawParticipantsProvider>
              </DrawAdminProvider>
            </NotificationProvider>
          </TopDonorsProvider>
        </WalletProvider>
      </ProfileSettingsProvider>
      <UpdateNotifier />
    </AuthProvider>
  );
}

export default App;